<template>
  <div id="new-contract-03">
    <div class="popup" :class="{ 'is-active': isFinalNewContractFlow }">
      <div class="overlay"></div>
      <div class="popup-body d-flex justify-content-center align-items-center pr-4 pl-4">
        <div class="card">
          <div class="card-body text-center">

            <div class="text-center p-2">
              <h3 class="font-weight-normal mb-2">ส่งคำขอเสร็จสมบูรณ์</h3>
              <p v-if="shouldShowDialogTextSentCredit" class="pr-4 pl-4">ถูกหักค่าธรรมเนียมจากการส่งคำขอด้วยเครดิตไปแล้ว {{display.viewCreditFee | money}} บาท</p>
              <p class="pr-4 pl-4">รอผู้ให้กู้ยอมรับเงื่อนไขและจะแจ้งผลผ่านทางเมนูแจ้งเตือน</p>
            </div>
            <a class="btn btn-primary btn-lg btn-block mt-5 mb-4" :href="$util.url('member/home')">กลับสู่หน้าหลัก</a>
          </div>
        </div>
      </div>
    </div>
      <div class="container mt-4 pr-4 pl-4 pb-1">
        <h3 v-if="type === 'money'" class="font-weight-normal mb-4">สัญญาเงินกู้</h3>
        <h3 v-if="type === 'thing'" class="font-weight-normal mb-4">สัญญาซื้อขาย</h3>
        <h3 v-if="type === 'mortgage'" class="font-weight-normal mb-4">สัญญาสินเชื่อบ้าน</h3>
        <div class="row">
          <div class="col profile-image-width-flex">
            <img
              class="profile-image rounded-circle shadow"
              :src="person.avatarPath"
            >
          </div>
          <div class="col pl-0 d-flex flex-column justify-content-center">
            <p class="m-0">
              <small v-if="type === 'money'">ผู้ให้กู้</small>
              <small v-if="type === 'thing'">ผู้ขาย</small>
              <small v-if="type === 'mortgage'">ผู้ให้สินเชื่อ</small>
            </p>
            <a href="#" @click="$router.go(-1)">
              <p class="text-primary m-0">{{person.partial_title}}{{person.name}} {{person.lastname}}</p>
            </a>
          </div>
        </div>
        <div class="row mt-4"></div>
        <template v-if="type === 'thing'">
            <div class="row">
                <div class="col">
                    <div class="form-group form-goobank">
                        <input class="form-control" name="thingName" type="text" v-model="thingPayload.thingName" />
                        <label for="thingName">ชื่อรายการสินค้า</label>
                        <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group form-goobank">
                        <input class="form-control" name="deposit" type="number" v-model.number="thingPayload.downPaymentAmount" />
                        <label for="deposit">เงินดาวน์ / เงินมัดจำ</label>
                        <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="type === 'mortgage'">
            <div class="row">
                <div class="col">
                    <div class="form-group form-goobank">
                        <input class="form-control" name="thingName" type="text" v-model="thingPayload.thingName" />
                        <label for="thingName">ชื่อรายการบ้าน</label>
                        <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div>
                    </div>
                </div>
            </div>
        </template>

        <div class="row">
          <div class="col">
            <div class="form-group form-goobank">
              <input class="form-control" name="amount" type="number" v-model.number="moneyPayload.amount" :class="{'is-invalid': moneyPayload.amount < 0}">
              <label v-if="type === 'money'" for="amount">จำนวนเงินที่ขอกู้</label>
              <label v-else-if="type === 'mortgage'" for="amount">จำนวนเงินที่ขอสินเชื่อ</label>
              <label v-else for="amount">ราคาขายสินค้า</label>
              <div class="invalid-feedback">ไม่สามารถเป็นจำนวนลบ</div>
            </div>
          </div>

          <div class="col" v-if="type === 'mortgage'">
              <div class="form-group form-goobank">
                  <input class="form-control" name="deposit" type="number" v-model.number="thingPayload.downPaymentAmount" />
                  <label for="deposit">เงินดาวน์</label>
                  <div class="invalid-feedback">กรอกข้อมูลให้ครบถ้วน</div>
              </div>
          </div>
        </div>
        <div class="row" v-if="type === 'mortgage'">
          <div class="col">
            <div class="form-group form-goobank">
              <input class="form-control" type="number" v-model="interestRaw" :class="{'is-invalid': (interestRaw < 0 || interestRaw > 100)}" />
              <label class="w-100" for="interest">ดอกเบี้ย (%)</label>
            </div>
          </div>

          <div class="col">
            <div class="form-group form-goobank">
              <input class="form-control"  v-model="interestDisputeRaw" :class="{'is-invalid': (interestRaw < 0 || interestRaw > 100)}"/>
              <label class="w-100" for="interest">ดอกเบี้ยผิดนัดชำระ (%)</label>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col">
            <div class="form-group form-goobank">
              <input
                  class="form-control is-default"
                  name="interest"
                  v-model="interestPercent"
                  inputmode="decimal"
                  placeholder="เช่น 8.50"
                />
              <label class="w-100" for="interest">ดอกเบี้ย (%) </label>
            </div>
          </div>

          <div class="col">
            <div class="form-group form-goobank">
              <input
                class="form-control is-default"
                name="interestDispute"
                v-model="interestDisputePercent"
                inputmode="decimal"
                placeholder="เช่น 15.00"
              />
              <label class="w-100" for="interestDispute">ดอกเบี้ยผิดนัดชำระ (%)</label>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-6">
            <div class="form-group form-goobank">
              <select class="form-control is-default" name="paymentDay" v-model="moneyPayload.payOnEvery" :disabled="true">
                <template v-for="option in display.optionLists.payOnEvery">
                    <option :key="option.value" :value="option.value">วันที่ {{option.display}}</option>
                </template>
              </select>
              <label class="w-100" for="paymentDay">ชำระเงินทุกวันที่</label>
            </div>
          </div>

          <div v-if="type === 'mortgage'" class="col-6">
            <div class="form-group form-goobank">

              <div class="row">
                <div class="col-6">
                  <div class="form-group form-goobank">
                    <label for="duration">ระยะเวลาที่ขอกู้</label>
                    <select class="form-control is-default" name="durationYear" v-model="moneyPayload.durationYear">
                        <template v-for="option in display.optionLists.durationYearMortgage">
                            <option :key="option.value" :value="option.value">{{option.display}}</option>
                        </template>
                    </select>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group form-goobank">
                    <label for="duration">&nbsp;</label>
                    <select class="form-control is-default" name="durationMonth" v-model="moneyPayload.durationMonth">
                        <template v-for="option in display.optionLists.durationMonthMortgage">
                            <option :key="option.value" :value="option.value">{{option.display}}</option>
                        </template>
                    </select>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div v-else class="col-6">
            <div class="form-group form-goobank">
              <label v-if="type === 'money'" for="duration">ระยะเวลาที่ขอกู้</label>
              <label v-else-if="type=== 'thing'" for="duration">ระยะเวลาการผ่อนสินค้า</label>
              <select class="form-control is-default" name="duration" v-model="moneyPayload.duration">
                  <template v-for="option in display.optionLists.duration">
                      <option :key="option.value" :value="option.value">{{option.display}}</option>
                  </template>
              </select>
            </div>
          </div>
        </div>
        <div v-if="type === 'thing' || type === 'mortgage'" class="mb-4">
          <h3 class="font-weight-normal mt-4 mb-4">รูปถ่ายแนบสัญญา</h3>
          <ImageUploader v-model="thingPayload.imageURLs" :api="$api.contract.request.thing.uploadPhoto"></ImageUploader>
        </div>
      </div>
      <div class="container" v-if="parseFloat(display.fee) >= 0.0 && parseFloat(display.payPerPeriod) > 0.0">
        <div class="row bg-white mt-2 pt-2 pr-2 pl-2">
          <div class="col text-center">
            <p class="m-2">ค่าธรรมเนียม</p>
            <template v-if="isCalculating()">
              <p>
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </p>
            </template>
            <template v-else>
              <p v-if="moneyPayload.amount > 0" class="h5">{{display.fee | money}}</p>
              <p class="h5" v-else>?</p>
            </template>
          </div>
          <!-- <div class="col text-center">
            <p class="m-2">ค่าธรรมเนียมผู้ให้กู้</p>
            <template v-if="isCalculating()">
              <p>
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </p>
            </template>
            <template v-else>
              <p class="h5" v-if="moneyPayload.amount > 0">{{display.lender_fee | money}}</p>
              <p class="h5" v-else>?</p>
            </template>
          </div> -->
        </div>
        <div class="row bg-white pb-2 pl-2 pr-2">
          <div class="col text-center">
            <p class="m-2">จำนวนงวด</p>
            <p class="h5" v-if="type == 'money' || type == 'thing'">{{moneyPayload.duration}} งวด</p>
            <p class="h5" v-else>{{ durationMortgage }} งวด</p>
          </div>
        </div>

        <div v-if="type === 'mortgage'" class="row bg-white mt-2 p-2">
          <div class="col text-center">
            <p class="m-0">ชำระเงินงวดละ</p>
            <template v-if="isCalculating()">
              <p>
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </p>
            </template>
            <template v-else>
              <p class="h2 text-danger" v-if="moneyPayload.amount > 0">{{ display.payPerPeriod | money}}</p>
              <p class="h2 text-danger" v-else>?</p>
            </template>
          </div>
        </div>
        <div v-else class="row bg-white mt-2 p-2">
          <div class="col text-center">
            <p class="m-0">ชำระเงินงวดละ</p>
            <template v-if="isCalculating()">
              <p>
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </p>
            </template>
            <template v-else>
              <p class="h2 text-danger" v-if="moneyPayload.amount > 0">{{ display.payPerPeriod | money}}</p>
              <p class="h2 text-danger" v-else>?</p>
            </template>
          </div>
        </div>


      </div>
      <div class="container">
        <error-cant-reach-server :errorData="errorData"  v-if="isCantReach" class="mt-4 mr-2 ml-2" :disableCTA="true" ctaText="ลองส่งอีกครั่ง"></error-cant-reach-server>
        <error-not-enough-data v-if="isNotEnoughData" class="mt-4 mr-2 ml-2" text="การสร้างคำขอ"></error-not-enough-data>
        <error-not-enough-money class="mt-2 mr-2 ml-2" v-if="isNotEnoughMoney" :side="isNotEnoughMoneySide"></error-not-enough-money>
      </div>
      <template v-if="!( (parseFloat(display.fee) >= 0.0 && parseFloat(display.payPerPeriod) > 0.0) )">
        <div class="row bg-white p-2">
          <div class="col text-center text-error">
            กรุณาตรวจสอบจำนวนเงินอีกครั้ง
            <template v-if="isCalculating()">
              <p class="mt-2">
                <div class="spinner-border text-primary" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </p>
            </template>
          </div>
        </div>
      </template>
      <div class="container mt-4 pr-4 pl-4 pb-1">
        <template v-if="parseFloat(display.fee) >= 0.0 && parseFloat(display.payPerPeriod) > 0.0">
          <button v-if="type === 'money'" class="btn btn-primary btn-lg btn-block" :disabled="moneyPayload.amount <= 0 || isCalculating() || isSubmitting" @click="submitNewContractMoney(false)">ส่งคำขอกู้เงิน</button>
          <button v-if="type === 'thing'" class="btn btn-primary btn-lg btn-block" :disabled="moneyPayload.amount <= 0 || isCalculating() || isSubmitting" @click="submitNewContractThing(false)">ส่งคำขอซื้อขาย</button>
          <button v-if="type === 'mortgage'" class="btn btn-primary btn-lg btn-block" :disabled="moneyPayload.amount <= 0 || isCalculating() || isSubmitting" @click="submitNewContractMortgage(false)">ส่งคำขอสินเชื่อ</button>

          <button v-if="type === 'money'" class="btn btn-primary btn-lg btn-block" :disabled="moneyPayload.amount <= 0 || isCalculating() || isSubmitting" @click="submitNewContractMoney(true)">ส่งคำขอกู้เงินและประวัติเครดิต</button>
          <button v-if="type === 'thing'" class="btn btn-primary btn-lg btn-block" :disabled="moneyPayload.amount <= 0 || isCalculating() || isSubmitting" @click="submitNewContractThing(true)">ส่งคำขอซื้อขายและประวัติเครดิต</button>
          <button v-if="type === 'mortgage'" class="btn btn-primary btn-lg btn-block" :disabled="moneyPayload.amount <= 0 || isCalculating() || isSubmitting" @click="submitNewContractMortgage(true)">ส่งคำขอสินเชื่อและประวัติเครดิต</button>

          <p class="mt-0 text-muted text-center">การส่งคำขอพร้อมประวัติเครดิตจะถูกหักค่าธรรมเนียมเพิ่มเติมทันที {{display.viewCreditFee | money}} บาท</p>
        </template>
        <button class="btn btn-light btn-lg btn-block" @click="$router.go(-1)">ย้อนกลับ</button>
      </div>
  </div>
</template>

<script>
import ImageUploader from '../../sub_components/ImageUploader'

export default {
    data: () => ({
        calculateTimeout: {},
        isPendingCalculateFee: true,
        shouldShowDialogTextSentCredit: false,
        interestRaw: 4.5,
        interestDisputeRaw: 7.5,
        type: '',
        calculateQueue: [],
        isSubmitting: false,
        isFinalNewContractFlow: false,
        isCantReach: false,
        errorData: {},
        isNotEnoughData: false,
        isNotEnoughMoney: false,
        isNotEnoughMoneySide: 'b',
        isPrepareSendingMoneyWithCredit: false,
        isPrepareSendingThingWithCredit: false,
        person: {
            id: -1,
            avatarPath: '',
            name: '',
        },
        thingPayload: {
            thingName: '',
            downPaymentAmount: 0.00,
            imageURLs: []
        },
        moneyPayload: {
            haigooId: -1,
            amount: 0,
            interest: 0.045,
            interestDispute: 0.075,
            duration: 1,
            payOnEvery: 28,
            durationYear: 3,
            durationMonth: 0
        },
        durationMortgage: 0,
        display: {
            payPerPeriod: '?',
            payPerPeriodDebug: '?',
            fee: '?',
            lender_fee: '?',
            viewCreditFee: '?',
            optionLists: {
                interest: [
                    { value: 0.00, display: '0 %' },
                    { value: 0.01, display: '1 %' },
                    { value: 0.02, display: '2 %' },
                    { value: 0.03, display: '3 %' },
                    { value: 0.04, display: '4 %' },
                    { value: 0.05, display: '5 %' },
                    { value: 0.06, display: '6 %' },
                    { value: 0.07, display: '7 %' },
                    { value: 0.08, display: '8 %' },
                    { value: 0.09, display: '9 %' },
                    { value: 0.10, display: '10 %' },
                    { value: 0.11, display: '11 %' },
                    { value: 0.12, display: '12 %' },
                    { value: 0.13, display: '13 %' },
                    { value: 0.14, display: '14 %' },
                    { value: 0.15, display: '15 %' },
                ],
                duration: [
                    { value: 1, display: '1 เดือน' },
                    { value: 2, display: '2 เดือน' },
                    { value: 3, display: '3 เดือน' },
                    { value: 4, display: '4 เดือน' },
                    { value: 5, display: '5 เดือน' },
                    { value: 6, display: '6 เดือน' },
                    { value: 7, display: '7 เดือน' },
                    { value: 8, display: '8 เดือน' },
                    { value: 9, display: '9 เดือน' },
                    { value: 10, display: '10 เดือน' },
                    { value: 11, display: '11 เดือน' },
                    { value: 12, display: '1 ปี' },
                    { value: 13, display: '1 ปี 1 เดือน' },
                    { value: 14, display: '1 ปี 2 เดือน' },
                    { value: 15, display: '1 ปี 3 เดือน' },
                    { value: 16, display: '1 ปี 4 เดือน' },
                    { value: 17, display: '1 ปี 5 เดือน' },
                    { value: 18, display: '1 ปี 6 เดือน' },
                    { value: 19, display: '1 ปี 7 เดือน' },
                    { value: 20, display: '1 ปี 8 เดือน' },
                    { value: 21, display: '1 ปี 9 เดือน' },
                    { value: 22, display: '1 ปี 10 เดือน' },
                    { value: 23, display: '1 ปี 11 เดือน' },
                    { value: 24, display: '2 ปี' },
                    { value: 25, display: '2 ปี 1 เดือน' },
                    { value: 26, display: '2 ปี 2 เดือน' },
                    { value: 27, display: '2 ปี 3 เดือน' },
                    { value: 28, display: '2 ปี 4 เดือน' },
                    { value: 29, display: '2 ปี 5 เดือน' },
                    { value: 30, display: '2 ปี 6 เดือน' },
                    { value: 31, display: '2 ปี 7 เดือน' },
                    { value: 32, display: '2 ปี 8 เดือน' },
                    { value: 33, display: '2 ปี 9 เดือน' },
                    { value: 34, display: '2 ปี 10 เดือน' },
                    { value: 35, display: '2 ปี 11 เดือน' },
                    { value: 36, display: '3 ปี' },
                    { value: 37, display: '3 ปี 1 เดือน' },
                    { value: 38, display: '3 ปี 2 เดือน' },
                    { value: 39, display: '3 ปี 3 เดือน' },
                    { value: 40, display: '3 ปี 4 เดือน' },
                    { value: 41, display: '3 ปี 5 เดือน' },
                    { value: 42, display: '3 ปี 6 เดือน' },
                    { value: 43, display: '3 ปี 7 เดือน' },
                    { value: 44, display: '3 ปี 8 เดือน' },
                    { value: 45, display: '3 ปี 9 เดือน' },
                    { value: 46, display: '3 ปี 10 เดือน' },
                    { value: 47, display: '3 ปี 11 เดือน' },
                    { value: 48, display: '4 ปี' },
                ],
                durationYearMortgage: [
                  // generate in populateDurationYearMortgage function
                ],
                durationMonthMortgage: [
                  // generate in populateDurationMonthMortgage function
                ],
                payOnEvery: []
            },
        }
    }),
    async created () {
        this.type = this.$route.params.type
        this.populateOptions();
        this.populateDurationYearMortgage();
        this.populateDurationMonthMortgage();
        const resultPerson = await this.$api.contract.listAvailableContractPerson(this.$route.query.id)
        const dataPerson = resultPerson.data
        if (!dataPerson.success || dataPerson.people.length === 0) {
            // TODO: tell user that id is wrong (unlikely) <- or unintended access
            this.$router.replace({ name: 'new-contract-01' })
        }
        this.person = dataPerson.people[0]
        this.moneyPayload.haigooId = this.person.id
    },
    watch: {
      interestRaw: function (val) {
        this.moneyPayload.interest = val / 100.00;
      },
      interestDisputeRaw: function (val) {
        this.moneyPayload.interestDispute = val / 100.00;
      },
      thingPayload: {
        async handler () {
          await this.emitCalculate()
        },
        deep: true
      },
      moneyPayload: {
        async handler () {
          this.durationMortgage = this.moneyPayload.durationYear * 12 + this.moneyPayload.durationMonth;
          await this.emitCalculate();
        },
        deep: true
      }
    },

    computed: {
        interestPercent: {
          get() {
            const rate = Number((this.moneyPayload && this.moneyPayload.interest) || 0);
            return (rate * 100).toFixed(2);
          },
          set(val) {
            const cleaned = this.normalizeDecimal(val);
            const n = cleaned === '' ? 0 : Number(cleaned);
            this.moneyPayload.interest = n / 100;
          }
        },

        interestDisputePercent: {
          get() {
            const rate = Number((this.moneyPayload && this.moneyPayload.interestDispute) || 0);
            return (rate * 100).toFixed(2);
          },
          set(val) {
            const cleaned = this.normalizeDecimal(val);
            const n = cleaned === '' ? 0 : Number(cleaned);
            this.moneyPayload.interestDispute = n / 100;
          }
        }
      },
    methods: {

      normalizeDecimal(val) {
        let v = String((val === null || val === undefined) ? '' : val).replace(',', '.');
        v = v.replace(/[^0-9.]/g, '');

        // ให้มีจุดได้แค่ 1 จุด
        const parts = v.split('.');
        if (parts.length > 2) v = parts[0] + '.' + parts.slice(1).join('');

        // จำกัดทศนิยม 2 ตำแหน่ง
        const ab = v.split('.');
        const a = ab[0];
        const b = ab[1];
        if (b !== undefined && b !== null) v = a + '.' + String(b).slice(0, 2);

        return v;
      },
      
      async emitCalculate () {
        this.isCantReach = false
        this.isNotEnoughMoney = false
        
        this.isPendingCalculateFee = true
        try {
          clearTimeout(this.calculateTimeout)
        } catch (e) { console.warn(e) }
        this.calculateTimeout = setTimeout(async () => {
          this.display.payPerPeriod = '?'
          this.display.fee = '?'
          this.display.lender_fee = '?'

          if(this.type === 'mortgage') {
            let dataTemp = await this.calculatePayPerPeriod();
            this.display.payPerPeriod = dataTemp.perPeriodRounded;
            this.display.payPerPeriodDebug = dataTemp.perPeriod;
          } else {
            this.display.payPerPeriod = await this.calculatePayPerPeriod();
          }

          const feeObj = await this.calculateFee()
          this.display.fee = feeObj.fee
          this.display.lender_fee = feeObj.lender_fee
          this.display.viewCreditFee = feeObj.viewCreditFee

          this.isPendingCalculateFee = false
        }, 1500)
      },
      isCalculating () {
        if (this.calculateQueue.length > 0 || this.isPendingCalculateFee) return true
        return false
      },
        async submitNewContractMoney (isSendingCredit) {
            this.isSubmitting = true
            this.shouldShowDialogTextSentCredit = isSendingCredit
            this.isPrepareSendingMoneyWithCredit = false
            this.isPrepareSendingThingWithCredit = false
            this.isCantReach = false
            const result = await this.$api.contract.request.newContract.money(this.moneyPayload, isSendingCredit)
            const data = result.data
            if (data.success) {
              this.isFinalNewContractFlow = true
            } else {
              if (data.code === 'W-PARAMS_EXPECTED') { 
                this.isNotEnoughData = true; 
              } else if (data.code === 'W-MONEY_INSUFFICENT') {
                this.isNotEnoughMoney = true; 
              } else if (data.code === 'W-MONEY_INSUFFICENT_B') {
                this.isNotEnoughMoney = true
                this.isNotEnoughMoneySide = 'b'
              } else if (data.code === 'W-MONEY_INSUFFICENT_L') {
                this.isNotEnoughMoney = true
                this.isNotEnoughMoneySide = 'l'
              } else {
                this.isCantReach = true
              }
              this.errorData = data
              this.isSubmitting = false
            }
        },
        async submitNewContractThing (isSendingCredit) {
            this.shouldShowDialogTextSentCredit = isSendingCredit
            this.isPrepareSendingMoneyWithCredit = false
            this.isPrepareSendingThingWithCredit = false
            this.isCantReach = false
            const result = await this.$api.contract.request.newContract.thing(this.moneyPayload, this.thingPayload, isSendingCredit)
            const data = result.data
            if (data.success) this.isFinalNewContractFlow = true
            else {
              if (data.code === 'W-PARAMS_EXPECTED') this.isNotEnoughData = true
              else if (data.code === 'W-MONEY_INSUFFICENT') this.isNotEnoughMoney = true
              else if (data.code === 'W-MONEY_INSUFFICENT_B') {
                this.isNotEnoughMoney = true
                this.isNotEnoughMoneySide = 'b'
              } else if (data.code === 'W-MONEY_INSUFFICENT_L') {
                this.isNotEnoughMoney = true
                this.isNotEnoughMoneySide = 'l'
              }
              else this.isCantReach = true
              this.errorData = data
            }
        },
        async submitNewContractMortgage (isSendingCredit) {
            this.isSubmitting = true
            this.shouldShowDialogTextSentCredit = isSendingCredit
            this.isPrepareSendingMoneyWithCredit = false
            this.isPrepareSendingThingWithCredit = false
            this.isCantReach = false

            this.moneyPayload.duration = this.durationMortgage;

            const result = await this.$api.contract.request.newContract.mortgage(this.moneyPayload, this.thingPayload, isSendingCredit)
            const data = result.data
            if (data.success) this.isFinalNewContractFlow = true
            else {
              if (data.code === 'W-PARAMS_EXPECTED') this.isNotEnoughData = true
              else if (data.code === 'W-MONEY_INSUFFICENT') this.isNotEnoughMoney = true
              else if (data.code === 'W-MONEY_INSUFFICENT_B') {
                this.isNotEnoughMoney = true
                this.isNotEnoughMoneySide = 'b'
              } else if (data.code === 'W-MONEY_INSUFFICENT_L') {
                this.isNotEnoughMoney = true
                this.isNotEnoughMoneySide = 'l'
              }
              else this.isCantReach = true
              this.errorData = data
              this.isSubmitting = false
            }
        },
        populateOptions () {
            if(this.type === 'mortgage') {
              [10,15,20,25,28].forEach((elm) => {
                  this.display.optionLists.payOnEvery.push({
                      value: elm,
                      display: elm
                  })
              });
              this.moneyPayload.payOnEvery = 28;
            } else {
              [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31].forEach((elm) => {
                  this.display.optionLists.payOnEvery.push({
                      value: elm,
                      display: elm
                  })
              });
            }
        },
        populateDurationYearMortgage () {
            this.display.optionLists.durationYearMortgage = [];
            let i = 3;
            for(i = 3; i<= 30; i++) {
                let year = i;
                let display = "";

                display = year + " ปี ";
                this.display.optionLists.durationYearMortgage.push({
                    value: i,
                    display: display
                });
            }
            this.moneyPayload.durationYear = 3;
        },
        populateDurationMonthMortgage () {
            this.display.optionLists.durationMonthMortgage = [];
            let i = 0;
            for(i = 0; i<= 11; i++) {
                let month = i;
                let display = "";

                display = month + " เดือน ";
                this.display.optionLists.durationMonthMortgage.push({
                    value: i,
                    display: display
                });
            }
            this.moneyPayload.durationMonth = 0;
        },
        async calculateFee () {
          this.calculateQueue.push(1)
          let resultFee;
          if(this.type == 'mortgage') {
            resultFee = await this.$api.contract.request.newContract.fee(this.moneyPayload.amount, this.thingPayload.downPaymentAmount, true)
          } else {
            resultFee = await this.$api.contract.request.newContract.fee(this.moneyPayload.amount, this.thingPayload.downPaymentAmount)
          }
          
          const dataFee = resultFee.data
          if (!dataFee.success) {
              this.calculateQueue.pop();
              this.isCantReach = true;
              this.errorData = dataFee;
              return {
                fee: -1,
                lender_fee: -1,
                viewCreditFee: -1
              }
          }
          this.calculateQueue.pop();
          return {
            fee: dataFee.fee,
            lender_fee: dataFee.lender_fee,
            viewCreditFee: dataFee.viewCreditFee
          }
        },
        async calculatePayPerPeriod () {
            this.calculateQueue.push(1)
            let result;
            if (this.type === 'money') {
              result = await this.$api.contract.calculatePayPerPeriod(this.moneyPayload.amount, this.moneyPayload.interest, this.moneyPayload.duration)
            } else if(this.type === 'thing') {
              result = await this.$api.contract.calculatePayPerPeriod(this.moneyPayload.amount, this.moneyPayload.interest, this.moneyPayload.duration, this.thingPayload.downPaymentAmount)
            } else if(this.type === 'mortgage') {
              result = await this.$api.contract.calculatePMT(this.moneyPayload.amount, this.moneyPayload.interest, this.durationMortgage, this.thingPayload.downPaymentAmount)
            }
            const data = result.data;
            if (!data.success) {
              this.calculateQueue.pop();
              this.isCantReach = true;
              this.errorData = data;
              return;
            }
            this.calculateQueue.pop();

            if(this.type === 'mortgage') {
              return data;
            } else {
              return data.perPeriod;
            }
        }
    },
    components: {
      ImageUploader
    }
};
</script>

<style lang="scss">
</style>
